import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getApiBaseUrl } from '../config';

const API_URL = getApiBaseUrl();

/** Fetches country once per session (free ipapi.co). */
function getCountryCached() {
  if (window.__analyticsCountry !== undefined) return window.__analyticsCountry;
  window.__analyticsCountry = null;
  fetch('https://ipapi.co/json/')
    .then((r) => r.json())
    .then((d) => {
      window.__analyticsCountry = d.country_name || d.country_code || null;
    })
    .catch(() => {});
  return null;
}

/** Records a page view to our backend for the Statistics panel. */
export function AnalyticsTracker() {
  const { pathname } = useLocation();
  const mounted = useRef(false);

  useEffect(() => {
    // Skip admin and non-public routes
    if (pathname.startsWith('/admin')) return;

    const path = pathname || '/';
    const country = getCountryCached();

    fetch(`${API_URL}/api/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, country }),
    }).catch(() => {});

    if (!mounted.current) mounted.current = true;
  }, [pathname]);

  return null;
}
